<h2 #pageHeader mat-dialog-title>Select Recipients</h2>
<mat-dialog-content style="min-width: 60vw; max-width: 80vw;">
    <div style="padding-top:10px;">
        <tabs #tab [setIndex]="tabIndex" *ngIf="tabNames && tabNames.length > 0" [tabNames]="tabNames"
              (selectionsChangeIndex)="tabChange($event)"></tabs>
    </div>
    <div style="overflow-x: hidden;overflow-y: auto;" [ngStyle]="{'height': gridHeight + 'px'}">
        <div *ngIf="selectedTab == 'Class View'">
            <ng-template [ngTemplateOutlet]="recipientControls"></ng-template>
            <mat-table #table [dataSource]="classViewDataSource" multiTemplateDataRows id="ClassViewDataTable"
                       #cvSort="matSort" matSort matSortDisableClear matSortActive="Course" matSortDirection="asc"
                       aria-label="Course View Table" tabindex="0">
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="max-width:60px;">
                        <span translate>More</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CV" style="max-width:60px;">
                        <span *ngIf="CV.Students.length > 0" aria-label="Expand row for more details"
                              (click)="toggleExpanded(CV)">
                            <i [ngClass]="checkExpanded(CV) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                               aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Select">
                    <mat-header-cell *matHeaderCellDef style="max-width:60px;">
                        <span>
                            <tyl-checkbox [(checked)]="massEmail.selectedClassesCheckAll"
                                          (change)="selectedClassesCheckAllClick();"></tyl-checkbox>
                        </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CV" style="max-width:60px;">
                        <tyl-checkbox [(checked)]="CV.IsSelectedForMassEmail" (change)="classClick(CV);"></tyl-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Course">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;">
                        <span translate>Course Name</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CV" style="min-width:200px;">{{CV.Course}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="SubjectCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Course</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CV" style="min-width:100px;">{{CV.SubjectCode}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Section">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Section</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CV" style="min-width:100px;">{{CV.Section}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Term">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Term</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CV" style="min-width:100px;">{{CV.Term}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="HomeRoom">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Home Room</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let CV" style="min-width:100px;">{{CV.IsHomeRoom ? 'Y' : ''}}</mat-cell>
                </ng-container>
                <!-- Detail Table -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let classRow" [attr.colspan]="7"
                        style="width:100%; padding-left: 120px;padding-right: 0px;">
                        <app-by-class-row-student [classRow]="classRow"></app-by-class-row-student>
                    </td>
                </ng-container>
                <mat-header-row *matHeaderRowDef="columnsToDisplayInClassView; sticky: true" id="CVdataHeader">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: columnsToDisplayInClassView; let i = index;" id="CVdataRow{{i}}"
                         tabindex="0" style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple>
                </mat-row>
                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                         [@detailExpand]="checkExpanded(row) && row.Students.length > 0 ? 'expanded' : 'collapsed'"
                         style="overflow: hidden">
                </mat-row>
            </mat-table>
        </div>
        <div *ngIf="selectedTab == 'Team View'">
            <ng-template [ngTemplateOutlet]="recipientControls"></ng-template>
            <mat-table #table [dataSource]="teamViewDataSource" multiTemplateDataRows id="TeamViewDataTable"
                       #tvSort="matSort" matSort matSortDisableClear matSortActive="TeamName" matSortDirection="asc"
                       aria-label="Team View Table" tabindex="0">
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="max-width:60px;">
                        <span translate>More</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let st" style="max-width:60px;">
                        <span *ngIf="st.Students.length > 0" aria-label="Expand row for more details"
                              (click)="toggleExpanded(st)">
                            <i [ngClass]="checkExpanded(st) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                               aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Select">
                    <mat-header-cell *matHeaderCellDef style="max-width:60px;">
                        <span>
                            <tyl-checkbox [(checked)]="massEmail.selectedTeamsCheckAll"
                                          (change)="selectedTeamsCheckAllClick();"></tyl-checkbox>
                        </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let st" style="max-width:60px;">
                        <tyl-checkbox [(checked)]="st.IsSelectedForMassEmail" (change)="teamClick(st);"></tyl-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="TeamName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;">
                        <span translate>Team Name</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let st" style="min-width:200px;">{{st.StudentTeamName}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let teamRow" [attr.colspan]="2"
                        style="width:100%; padding-left: 120px;padding-right: 0px;">
                        <app-by-team-row-student [teamRow]="teamRow"></app-by-team-row-student>
                    </td>
                </ng-container>
                <mat-header-row *matHeaderRowDef="columnsToDisplayInTeamView; sticky: true" id="CVdataHeader">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: columnsToDisplayInTeamView; let i = index;" id="STdataRow{{i}}"
                         tabindex="0" style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple>
                </mat-row>
                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                         [@detailExpand]="checkExpanded(row) && row.Students.length > 0 ? 'expanded' : 'collapsed'"
                         style="overflow: hidden">
                </mat-row>
            </mat-table>
        </div>
        <div *ngIf="selectedTab == 'List View'">
            <ng-template [ngTemplateOutlet]="recipientControls"></ng-template>
            <mat-table #table [dataSource]="listViewDataSource" multiTemplateDataRows id="ListViewDataTable"
                       #tvSort="matSort" matSort matSortDisableClear matSortActive="ListName" matSortDirection="asc"
                       aria-label="List View Table" tabindex="0">
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="max-width:60px;">
                        <span translate>More</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let sl" style="max-width:60px;">
                        <span *ngIf="sl.MassEmailStudents.length > 0" aria-label="Expand row for more details"
                              (click)="toggleExpanded(sl)">
                            <i [ngClass]="checkExpanded(sl) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                               aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Select">
                    <mat-header-cell *matHeaderCellDef style="max-width:60px;">
                        <span>
                            <tyl-checkbox [(checked)]="massEmail.selectedListsCheckAll"
                                          (change)="selectedListsCheckAllClick();"></tyl-checkbox>
                        </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let sl" style="max-width:60px;">
                        <tyl-checkbox [(checked)]="sl.IsSelectedForMassEmail" (change)="listClick(sl);"></tyl-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="ListName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;">
                        <span translate>List Name</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let sl" style="min-width:200px;">{{sl.Name}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let listRow" [attr.colspan]="2"
                        style="width:100%; padding-left: 120px;padding-right: 0px;">
                        <app-by-list-row-student [listRow]="listRow"></app-by-list-row-student>
                    </td>
                </ng-container>
                <mat-header-row *matHeaderRowDef="columnsToDisplayInListView; sticky: true" id="LVdataHeader">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: columnsToDisplayInListView; let i = index;" id="SLdataRow{{i}}"
                         tabindex="0" style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple>
                </mat-row>
                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                         [@detailExpand]="checkExpanded(row) && row.MassEmailStudents.length > 0 ? 'expanded' : 'collapsed'"
                         style="overflow: hidden">
                </mat-row>
            </mat-table>
        </div>
        <div *ngIf="selectedTab == 'Student View' || selectedTab == 'Students'">
            <ng-template [ngTemplateOutlet]="recipientControls"></ng-template>
            <mat-table [dataSource]="studentViewDataSource" #svSort="matSort" matSort matSortDisableClear
                       matSortActive="Name" matSortDirection="asc" id="studentViewDataTable"
                       aria-label="Student View Table"
                       tabindex="0">
                <ng-container matColumnDef="Select">
                    <mat-header-cell *matHeaderCellDef style="max-width:60px;padding-left:0px;">
                        <span>
                            <tyl-checkbox [(checked)]="massEmail.selectedStudentsCheckAll"
                                          (change)="selectedStudentsCheckAllClick();"></tyl-checkbox>
                        </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let SV" style="max-width:60px;padding-left:0px;">
                        <tyl-checkbox [(checked)]="SV.IsSelected" (change)="studentClick(SV);"></tyl-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="StudentNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Student #</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let SV" style="min-width:100px;">{{SV.StudentNumber}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Name</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let SV" style="min-width:100px;">{{SV.Name}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="GradeLevel">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Grade Level</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let SV" style="min-width:100px;">{{SV.GradeLevel}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Email">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:300px;">
                        <span translate>Email Address</span>
                    </mat-header-cell>
                    <mat-cell
                        [ngStyle]="{'background-color': (SV.Email == '' || SV.Email == null) ? '#ffff99' : 'none'}"
                        *matCellDef="let SV" style="min-width:300px">{{SV.Email}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Course">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Class</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let SV" style="min-width:100px;">
                        <div style="line-height:normal" *ngIf="massEmail.ReferringPage == 'My Classes'">
                            <div *ngFor="let class of selectedClasses | selectRecipients : SV.SubjectSections : 'My Classes'">
                                <span>
                                    <td style="width:15px;"><span
                                        *ngIf="(loginSettings.V10 && SV.SelectedClasses[class.SSEC_ID]) || (!loginSettings.V10 && SV.SelectedClasses[class.Id])"><img
                                        src="./assets/images/Check.png" style="height:15px;"/></span></td>
                                    <td>{{class.Course}}</td>
                                </span>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- Team -->
                <ng-container matColumnDef="Team">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Team</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let SV" style="min-width:100px;">
                        <div style="line-height:normal" *ngIf="massEmail.ReferringPage == 'Student Teams'">
                            <div *ngFor="let team of selectedStudentTeams | selectRecipients : SV.StudentTeams : 'Student Teams'">
                                <span>
                                    <td style="width:15px;"><span
                                        *ngIf="SV.SelectedTeams[team.Id]"><img
                                        src="./assets/images/Check.png" style="height:15px;"/></span></td>
                                    <td>{{team.StudentTeamName}}</td>
                                </span>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- List -->
                <ng-container matColumnDef="List">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>List</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let SL" style="min-width:100px;">
                        <div style="line-height:normal" *ngIf="massEmail.ReferringPage == 'Student Lists'">
                            <div *ngFor="let list of selectedStudentLists | selectRecipients : SL.StudentLists : 'Student Lists'">
                                <span>
                                    <td style="width:15px;"><span
                                        *ngIf="SL.SelectedLists[list.ID]"><img
                                        src="./assets/images/Check.png" style="height:15px;"/></span></td>
                                    <td>{{list.Name}}</td>
                                </span>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columnsToDisplayInStudentView; sticky: true" id="SVdataHeader">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: columnsToDisplayInStudentView; let i = index;"
                         id="SVdataRow{{i}}" tabindex="0" style="padding:0px;overflow:hidden;border-bottom-width:1px;"
                         matRipple>
                </mat-row>
            </mat-table>
        </div>
        <div *ngIf="selectedTab == 'Additional'" style="margin-top: 10px">
            <div style="margin-top: 10px; margin-bottom: 15px;">
                <tyl-form-field label='To' [hintLabel]="'Separate addresses with semicolons.'" [fullWidth]="true"
                                style="width:100%;">
                    <input matInput [(ngModel)]="massEmail.AdditionalRecipients.to" id='inpTo' type='text'/>
                </tyl-form-field>
            </div>
            <div style="margin-top: 10px; margin-bottom: 15px;">
                <tyl-form-field label='CC' [hintLabel]="'Separate addresses with semicolons.'" [fullWidth]="true"
                                style="width:100%;">
                    <input matInput [(ngModel)]="massEmail.AdditionalRecipients.cc" id='inpCC' type='text'/>
                </tyl-form-field>
            </div>
            <div style="margin-top: 10px; margin-bottom: 15px;">
                <tyl-form-field label='BCC' [hintLabel]="'Separate addresses with semicolons.'" [fullWidth]="true"
                                style="width:100%;">
                    <input matInput [(ngModel)]="massEmail.AdditionalRecipients.bcc" id='inpBCC' type='text'/>
                </tyl-form-field>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions #pageFooter class="sis-app-footer" style="position: sticky;padding: 0px;">
    <div class="flex-footer-left">
        <tyl-button style="float:right;" image="previous arrow.png" label="Back to {{massEmail.ReferringPage}}"
                    (clickEvent)="backClick()"></tyl-button>
        <tyl-button image="Expand All.png" label="Expand All" *ngIf="selectedTab == 'Class View'"
                    (clickEvent)="expandAll(true)"></tyl-button>
        <tyl-button image="Collapse All.png" label="Collapse All" *ngIf="selectedTab == 'Class View'"
                    (clickEvent)="expandAll(false)"></tyl-button>
    </div>
    <div class="flex-footer-right">
        <error-prompt style="float:right;" [errorList]="errorList"></error-prompt>
        <tyl-button *ngIf="!massEmail.recipientsSelected" style="float:right;" image="next arrow.png" label="Next" (clickEvent)="nextClick()"></tyl-button>
        <tyl-button *ngIf="!massEmail.recipientsSelected" style="float:right;" image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        <tyl-button *ngIf="massEmail.recipientsSelected" style="float:right;" image="next arrow.png" label="Save" (clickEvent)="nextClick()"></tyl-button>
        <tyl-button *ngIf="massEmail.recipientsSelected" style="float:right;" image="Cancel.png" label="Cancel" (clickEvent)="closeModalClick()"></tyl-button>
    </div>
</mat-dialog-actions>

<ng-template #recipientControls>
    <table #tblControls style="width:100%;background-color:#ffff99;margin-top: 10px;">
        <tr>
            <td style="padding-left:10px; width: 60px">
                <tyl-form-field label="Students" errorMessage="" style="padding-left:10px;">
                    <mat-select [value]="massEmail.StudentRecipientType"
                        (valueChange)="studentRecipientTypeChange($event)"
                        id="dropdownStudentRecipientType"
                        aria-label="Select item to Select Recipient Type">
                        <mat-option value="To" translate>To</mat-option>
                        <mat-option value="CC" translate>CC</mat-option>
                        <mat-option value="BCC" translate>BCC</mat-option>
                        <mat-option value="" translate>Do Not Include</mat-option>
                    </mat-select>
                </tyl-form-field>
            </td>
            <td style="padding-left:10px;">
                <tyl-form-field label="{{householdParentLabel}}" errorMessage="">
                    <mat-select [(value)]="massEmail.HouseholdRecipientType"
                                (selectionChange)="householdRecipientTypeChanged()" id="dropdownHouseholdRecipientType"
                                aria-label="Select item to Select Household Recipient Type" disableOptionCentering>
                        <mat-option value="BCC" translate>BCC</mat-option>
                        <mat-option value="" translate>Do Not Include</mat-option>
                    </mat-select>
                </tyl-form-field>
            </td>
            <td style="padding-left:10px;" *ngIf="loginSettings.MassEmailContactsGrouped">
                <tyl-form-field label="Non-Resident Parents" errorMessage="">
                    <mat-select [(value)]="massEmail.NonHouseholdRecipientType" id="dropdownnonHouseholdRecipientType"
                                aria-label="Select item to Select non Household Recipient Type" disableOptionCentering>
                        <mat-option value="BCC" translate>BCC</mat-option>
                        <mat-option value="" translate>Do Not Include</mat-option>
                    </mat-select>
                </tyl-form-field>
            </td>
            <td style="padding-left:10px;">
                <tyl-checkbox id="chkSendEmailToTeachers" [(checked)]="massEmail.SendEmailToTeachers"
                              *ngIf="massEmail.ReferringPage == 'My Classes'"
                              style="padding-right: 10px;" aria-label="Send Email To Teachers">
                    Send email to Class Teachers / Co-Teachers
                </tyl-checkbox><br>
                <tyl-checkbox id="chkSendEmailToTeamStaffMembers" [(checked)]="massEmail.SendEmailToTeamStaffMembers"
                              *ngIf="v10 && (massEmail.ReferringPage == 'My Classes' || massEmail.ReferringPage == 'Attendance' || massEmail.ReferringPage == 'Gradebook' || massEmail.ReferringPage == 'Data Query')" 
                              style="padding-right: 10px;" aria-label="Send Email To Team Staff Members">
                Send email to Team Staff Members    
                </tyl-checkbox>
            </td>
        </tr>
        <tr>
            <td style="padding: 10px;"></td>
            <td style="white-space: nowrap; padding: 10px;"
                [ngStyle]="{'width': loginSettings.MassEmailContactsGrouped ? '150px' : ''}">
                <tyl-form-field label="Contact Type" errorMessage="" *ngIf="!loginSettings.MassEmailContactsGrouped">
                    <mat-select id="dropdownContactTypes" [(ngModel)]="selectedContactType"
                                [disabled]="massEmail.HouseholdRecipientType == null || massEmail.HouseholdRecipientType == ''"
                                aria-label="Select Contact Types" (click)="contactTypeClick()"
                                [formControl]="contactTypes"
                                multiple required disableOptionCentering>
                        <mat-select-trigger>
                            <span *ngIf="contactTypes.value?.length >= 1 " [innerHtml]="matTriggerValue()"
                                  [ngStyle]="{'font-style':(contactTypes.value?.length >= 2 && contactTypes.value?.length !=massEmail.ContactTypes.length ? 'italic' : 'none') }"></span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let contactType of massEmail.ContactTypes"
                                    (click)="testContactType(contactType)"
                                    [value]="contactType.label">{{contactType.label}}
                        </mat-option>
                    </mat-select>
                </tyl-form-field>
            </td>
            <td *ngIf="loginSettings.MassEmailContactsGrouped"
                style="white-space: nowrap;">
                <tyl-checkbox id="chkIncludeAll" aria-label="Include all even if did not request mailings"
                    [disabled]="massEmail.NonHouseholdRecipientType == null || massEmail.NonHouseholdRecipientType == ''"
                    [(checked)]="massEmail.IncludeAll">
                    Include all even if did not request mailings
                </tyl-checkbox>
            </td>
            <td style="white-space: nowrap; padding-left: 10px;">
                <tyl-checkbox id="chkMassEmailOneEmailPerFamily"
                    aria-label="Include only one email per household"
                    [disabled]="!!massEmail.StudentRecipientType"
                    [(checked)]="massEmail.OneEmailPerHousehold">
                    Send once per household
                </tyl-checkbox>
            </td>
        </tr>
    </table>
</ng-template>
